// import { SearchBar } from "./SearchBar";
import { CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { PulseFields } from "./PulseFields";
import type { PulseWithPostData } from "../../types/pulse.types";

// Skeleton for pulse list item
function PulseListSkeleton() {
  return (
    <div className="grid h-auto w-full grid-cols-[1fr_auto] items-start gap-2.5 border-b border-neutral-200 p-3 pb-6">
      <div className="space-y-3">
        <Skeleton className="h-9 w-64" />
        <Skeleton className="h-4 w-48" />
        <div className="mt-3 space-y-2">
          <Skeleton className="h-4 w-full max-w-md" />
          <Skeleton className="h-4 w-3/4 max-w-sm" />
        </div>
      </div>
      <div className="flex gap-2">
        <Skeleton className="h-[45px] w-[45px] rounded-md" />
        <Skeleton className="h-[45px] w-[45px] rounded-md" />
      </div>
    </div>
  );
}

export default function PulseList({
  data,
  isLoading,
  error,
}: {
  data: { data: PulseWithPostData[] } | undefined;
  isLoading: boolean;
  error: Error | null;
}) {
  return (
    <div className="flex min-h-full flex-col gap-5 pr-3">
      {/* Header row */}
      <div className="flex items-center justify-between">
        <div>
          <CardTitle className="text-[28px] leading-[36px] -tracking-wide text-neutral-950">
            Pulse Monitoring
          </CardTitle>
        </div>
      </div>

      {/* Tabs */}
      <div className="min-h-0 flex-1">
        <div className="">
          <div>
            {isLoading && (
              <div className="space-y-4">
                <PulseListSkeleton />
                <PulseListSkeleton />
                <PulseListSkeleton />
              </div>
            )}
            {error && (
              <div className="flex items-center justify-center py-8 text-red-600">
                <i className="ri-error-warning-line text-xl"></i>
                <span className="ml-2">
                  Error loading pulses: {error.message}
                </span>
              </div>
            )}
            {!isLoading && !error && data?.data && data.data.length === 0 && (
              <div className="flex h-64 w-full items-center justify-center">
                <div className="text-center">
                  <i className="ri-radar-line mb-4 text-5xl text-gray-400"></i>
                  <p className="mb-2 text-lg font-medium text-gray-600">
                    No pulses found
                  </p>
                </div>
              </div>
            )}
            {!isLoading && !error && data?.data && data.data.length > 0 && (
              <>
                {data.data.map((pulse: PulseWithPostData) => (
                  <div
                    key={pulse._id}
                    className="rounded-lg transition-all duration-300 hover:bg-neutral-300/30"
                  >
                    <PulseFields pulse={pulse} showPostDataStatus={false} />
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
